module.exports = __webpack_public_path__ + "img/faq-grid.48478ead.png";